import React from 'react';
import _ from 'lodash';

import {
  ArrowDropUp,
  ArrowDropDown
} from '@mui/icons-material';

import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';



const ContainerDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
});

const ItemContainerDiv = styled('div')({
  flex: '1 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
});

const ButtonsContainerDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
});

const ArrowButton = styled(Button)({
  minWidth: 'unset',
  padding: 0
});



export interface IItem {
  id: string;
  fnGenElComponent: (buttons: JSX.Element, selectedId: string) => JSX.Element;
}

export interface IProps {
  selectedId?: string;
  onSelect?: (id: string) => void;
  itemsById: Record<string, IItem>;
  idOrdering: string[];
  onChangeIdOrdering: (idOrdering: string[]) => void;
  isDisabled?: boolean;
}

export const FC: React.FC<IProps> = props => {
  const items = React.useMemo(
    () => _.compact(_.map(props.idOrdering, id => props.itemsById[id])),
    [
      props.itemsById,
      props.idOrdering
    ]
  );



  function handleClickUp(event: React.MouseEvent, fromIndex: number) {
    event.stopPropagation();
    props.onChangeIdOrdering([
      ...props.idOrdering.slice(0, fromIndex - 1),
      props.idOrdering[fromIndex],
      props.idOrdering[fromIndex - 1],
      ...props.idOrdering.slice(fromIndex + 1)
    ]);
  }



  function handleClickDown(event: React.MouseEvent, fromIndex: number) {
    event.stopPropagation();
    props.onChangeIdOrdering([
      ...props.idOrdering.slice(0, fromIndex),
      props.idOrdering[fromIndex + 1],
      props.idOrdering[fromIndex],
      ...props.idOrdering.slice(fromIndex + 2)
    ]);
  }



  return (
    <ContainerDiv>
      {_.map(items, (item, index) => (
        <ItemContainerDiv
          key={item.id}
          onClick={() => props.onSelect?.(item.id)}>

          {item.fnGenElComponent((
            <ButtonsContainerDiv>
              <ArrowButton
                variant="text"
                onClick={event => handleClickUp(event, index)}
                disabled={props.isDisabled || index === 0}>
                <ArrowDropUp />
              </ArrowButton>

              <ArrowButton
                variant="text"
                onClick={event => handleClickDown(event, index)}
                disabled={props.isDisabled || index === items.length - 1}>
                <ArrowDropDown />
              </ArrowButton>
            </ButtonsContainerDiv>
          ), props.selectedId ?? '')}

        </ItemContainerDiv>
      ))}
    </ContainerDiv>
  );
};
